// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useRef } from 'react';
import Rq from './RequireField';
import '../../../styles/components/FileUploader.css';

export default ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  header,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  required,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  width,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  height,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  full,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  fileStatus,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  name,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  noDragnDrop,
}) => {
  let w = full ? '100%' : '100px';
  w = width || w;

  const inputRef = useRef(null);
  const uploadImgButtonDisplay = noDragnDrop ? 'block' : 'none';
  const dragnDropDisplay = noDragnDrop ? 'none' : 'block';

  return (
    <>
      <button
        type='button'
        className='btn btn-def small btn-sm'
        style={{ marginBottom: '15px', display: uploadImgButtonDisplay }}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        onClick={() => inputRef?.current?.click()}
      >
        Upload Image
      </button>
      <div
        className='file-input-wrapper'
        style={{
          width: w,
          height: height || '100px',
          display: dragnDropDisplay,
        }}
      >
        <div
          className='area-file-input'
          style={{ width: w, height: height || '100px' }}
        >
          <div>
            {`+ Upload ${header}`}
            {required && <Rq />}
          </div>
          <div className='file-sub-header'>(*.jpg, *.png only)</div>
        </div>
        <input
          ref={inputRef}
          multiple
          data-type={name}
          onChange={onChange}
          accept='.jpg, .png'
          type='file'
        />
        {fileStatus && <span>{fileStatus}</span>}
      </div>
    </>
  );
};
